<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > 科普知识</div>
        <div class="title-nav">
          <div class="nav-li" v-for="(item, index) in navItems" :key="index" :class="{ active: activeIndex === item.id }" @click="setActive(item.id)">
            {{ item.name }}
          </div>
        </div>
        <news v-if="news.length > 0" :news="news" :page="page" @sizeChange="sizeChange" @currentChange="currentChange" />
        <empty class="empty-margin" v-if="news.length <= 0"></empty>
      </div>
    </div>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import course from "@/components/base/course";
import news from "@/components/base/news";
import { getPageList, getInformationType } from '@/api/home'
import empty from "@/components/empty/index";

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, course, news, empty },
  data() {
    return {
      selectedIndex: 4,
      navItems: [],
      news: [],
      page: {
        number: 1,
        limit: 10,
        total: 0,
      },
      activeIndex: '',
      searchTitle: '',
    }
  },
  watch: {
    "$route" (to, from) {
      this.searchTitle = to.query.title ? to.query.title : ''
      this.page.number = 1
      this.getPageList()
    },
  },
  methods: {
    setActive(index) {
      this.activeIndex = index; // 设置当前激活的项
      this.getPageList()
    },
    // 列表查询资讯类型
    async getInformationType() {
      await getInformationType({
        categories: 'SCIENCE',
      }).then(res => {
        this.navItems = res.data
        this.activeIndex = res.data.length > 0 ? res.data[0].id : ''
      })
    },
    async getPageList() {
      await getPageList({
        number: this.page.number,
        limit: this.page.limit,
        checkStatus: 'HAVE_RELEASED',
        categories: 'SCIENCE',
        type: this.activeIndex,
        title: this.searchTitle,
      }).then(res => {
        this.news = res.data
        this.page.total = res.totalCount
      })
    },
    async Initialization() {
      await this.getInformationType()
      await this.getPageList()
    },
    sizeChange(value) {
      this.page.number = 1
      this.page.limit = value
      this.getPageList()
    },
    currentChange(value) {
      this.page.number = value
      this.getPageList()
    },
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    if (this.$route.query.title) {
      this.searchTitle = this.$route.query.title
    }
    wow.init();
    this.Initialization()
  }
}
</script>

<style lang="less" scoped>
.head-box {
  background: url("~@/assets/images/b2.png") no-repeat;
  background-size: 100% 100%;
}

.center-box {
  padding-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/NewsInformation/index.vue